import { isMac } from 'src/app/graph/explorerPage/helpers/isMac';

import { ModifiersKeys } from './useKeypressListener';

export interface HotkeyDictionaryItem {
  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code/code_values
  actionName: string;
  keyboardEventCode: string;
  modifierKeys: ModifiersKeys;
  label: string;
}

export const boldSelection: HotkeyDictionaryItem = {
  actionName: 'Bold Selection',
  keyboardEventCode: 'KeyB',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + b`,
};

export const italicizeSelection: HotkeyDictionaryItem = {
  actionName: 'Italize Selection',
  keyboardEventCode: 'KeyI',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + i`,
};

export const linkSelection: HotkeyDictionaryItem = {
  actionName: 'Link Selection',
  keyboardEventCode: 'KeyK',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + k`,
};

export const submitOperation: HotkeyDictionaryItem = {
  actionName: 'Execute Operation',
  keyboardEventCode: 'Enter',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + Enter`,
};

export const saveOperation: HotkeyDictionaryItem = {
  actionName: 'Save Operation',
  keyboardEventCode: 'KeyS',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + S`,
};

export const saveOperationAs: HotkeyDictionaryItem = {
  actionName: 'Save Operation As',
  keyboardEventCode: 'KeyS',
  modifierKeys: isMac
    ? { metaKey: true, shiftKey: true }
    : { ctrlKey: true, shiftKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + ⇧ + S`,
};

export const toggleSearch: HotkeyDictionaryItem = {
  actionName: 'Search Schema',
  keyboardEventCode: 'KeyK',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + K`,
};

export const toggleShortcutModal: HotkeyDictionaryItem = {
  actionName: 'Toggle Shortcuts Modal',
  keyboardEventCode: 'Slash',
  modifierKeys: {
    altKey: true,
    shiftKey: false,
  },
  label: `${isMac ? 'Option' : 'Alt'} + ?`,
};

export const openCommandPalette: HotkeyDictionaryItem = {
  actionName: 'Open Command Palette',
  keyboardEventCode: 'F1',
  modifierKeys: {},
  label: `F1`,
};

export const escape: HotkeyDictionaryItem = {
  actionName: 'Escape',
  keyboardEventCode: 'Escape',
  modifierKeys: {},
  label: `Escape`,
};

export const peekPreview: HotkeyDictionaryItem = {
  actionName: 'Peek Preview',
  keyboardEventCode: 'Hover',
  modifierKeys: {},
  label: `${isMac ? '⌘' : 'Ctrl'} + hover on type`,
};

export const toggleCommentVisibility: HotkeyDictionaryItem = {
  actionName: 'Toggle Comment Visibility',
  keyboardEventCode: 'KeyH',
  modifierKeys: isMac
    ? { metaKey: true, shiftKey: true }
    : { ctrlKey: true, shiftKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + Shift + H`,
};

export const toggleDeprecatedVisibility: HotkeyDictionaryItem = {
  actionName: 'Toggle Deprecated Types Visibility',
  keyboardEventCode: 'KeyD',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + D`,
};

export const saveRevision: HotkeyDictionaryItem = {
  actionName: 'Save Revision',
  keyboardEventCode: 'KeyS',
  modifierKeys: isMac ? { metaKey: true } : { ctrlKey: true },
  label: `${isMac ? '⌘' : 'Ctrl'} + S`,
};
